export var DepositCategoryType;
(function (DepositCategoryType) {
    DepositCategoryType["ONLINE"] = "online";
    DepositCategoryType["ONLINE_MANUAL"] = "online_manual";
    DepositCategoryType["SCAN_WECHAT"] = "scan_wechat";
    DepositCategoryType["SCAN_ALIPAY"] = "scan_alipay";
    DepositCategoryType["GOUBAO"] = "goubao";
    DepositCategoryType["TOPAY"] = "topay";
    DepositCategoryType["EBPAY"] = "ebpay";
    DepositCategoryType["MANUAL"] = "manual";
    DepositCategoryType["CRYPTO"] = "crypto";
    DepositCategoryType["UNION_PAY_QUICK"] = "union_pay_quick";
    DepositCategoryType["UNION_PAY_CLOUD"] = "union_pay_cloud";
    DepositCategoryType["CGPAY"] = "cgpay";
    DepositCategoryType["CGPAY_USDT"] = "cgpay_usdt";
    DepositCategoryType["KOIPAY"] = "koipay";
    DepositCategoryType["E_CNY"] = "e_cny";
    DepositCategoryType["PAY988"] = "pay988";
    DepositCategoryType["PAY808"] = "pay808";
    DepositCategoryType["KDPAY"] = "kdpay";
})(DepositCategoryType || (DepositCategoryType = {}));
//# sourceMappingURL=DepositCategoryType.js.map